import React from 'react'
import AppDropdownWithPagination, {
  IExtraOptions,
} from './AppDropdownWithPagination'
import { IWithPaginationRequestSearch } from '../../core/api/dto/BaseDto'
import { useTranslation } from 'react-i18next'

interface IAppMultiDropdownWithPagination<T, TKey> {
  value: T[] | []
  propToShowInList?: TKey // если data массив строк, то не передаем propToShowInList и propToShowInInput
  propToShowInInput: TKey
  sparePropToShowInList?: TKey
  extraPropToShowInList?: TKey
  getterData: (
    params: IWithPaginationRequestSearch | any | null,
    extraParams?: { skip?: boolean },
  ) => any
  onChange: (
    value: T[],
  ) => void | React.Dispatch<React.SetStateAction<[] | T[]>>
  resetValueHandler?: () => void
  label?: string
  placeholder?: string
  extraOptions?: IExtraOptions
  disabled?: boolean
  error?: string | null
  id?: string
  emptyListMessage?: string
  require?: boolean
  border?: boolean
  fullWidth?: boolean
  minWidth?: boolean
  tag?: boolean
  labelList?: string
  showArchivedItems?: boolean //контролирует показ архивированных позиций
  limit?: number
}

export const AppMultiDropdownWithPagination = <T, TKey extends keyof T>({
  value,
  onChange,
  propToShowInList,
  propToShowInInput,
  extraPropToShowInList,
  sparePropToShowInList,
  getterData,
  label,
  placeholder,
  extraOptions,
  disabled,
  error,
  emptyListMessage,
  resetValueHandler,
  require,
  border,
  fullWidth,
  minWidth,
  id,
  tag,
  labelList,
  showArchivedItems,
  limit,
}: IAppMultiDropdownWithPagination<T, TKey>) => {
  const { t } = useTranslation()
  const onChangeHandler = (newItem: T) => {
    const duplicate = value.find(
      (item) =>
        String(item[propToShowInInput]) === String(newItem[propToShowInInput]),
    )
    if (!!duplicate) {
      const removeDuplicate = value.filter(
        (item) =>
          String(item[propToShowInInput]) !==
          String(duplicate[propToShowInInput]),
      )
      onChange(removeDuplicate)
      return
    }
    onChange([...value, newItem])
  }
  const onDeleteFromList = (valueID: string | number) => {
    if (propToShowInInput) {
      const removeDuplicate = value.filter(
        (item) => String(item[propToShowInInput]) !== String(valueID),
      )
      onChange(removeDuplicate)
    }
  }

  return (
    <AppDropdownWithPagination
      label={label}
      value={null}
      onChange={onChangeHandler}
      getterData={getterData}
      multiValue={value}
      propToShowInList={propToShowInList}
      propToShowInInput={propToShowInInput}
      placeholder={
        value.length === 0 ? placeholder : `${t('Выбрано')} : ${value.length}`
      }
      resetValueHandler={resetValueHandler}
      extraOptions={extraOptions}
      disabled={disabled}
      error={error}
      require={require}
      emptyListMessage={emptyListMessage}
      border={border}
      fullWidth={fullWidth}
      minWidth={minWidth}
      id={`-m${id || ''}`}
      extraPropToShowInList={extraPropToShowInList}
      sparePropToShowInList={sparePropToShowInList}
      tag={tag}
      labelList={labelList}
      onDeleteFromList={onDeleteFromList}
      showArchivedItems={showArchivedItems}
      limit={limit}
    />
  )
}
